import axiosInstance from './axiosInstance';
import { clearCache } from '../utils/lookupCache';

const API_URL = process.env.REACT_APP_API_URL;

// GET all locations
export const getLocations = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/locations`);
    return response.data;
  } catch (error) {
    console.error("Error fetching locations:", error.response?.data || error);
    throw error;
  }
};

// GET a single location
export const getLocationById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/locations/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching location:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new location
export const createLocation = async (locationData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/locations`, locationData);
    clearCache('locations');
    return response.data;
  } catch (error) {
    console.error("Error creating location:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing location
export const updateLocation = async (id, locationData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/locations/${id}`, locationData);
    clearCache('locations');
    return response.data;
  } catch (error) {
    console.error("Error updating location:", error.response?.data || error);
    throw error;
  }
};

// DELETE a location
export const deleteLocation = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/locations/${id}`);
    clearCache('locations');
    return response.data;
  } catch (error) {
    console.error("Error deleting location:", error.response?.data || error);
    throw error;
  }
};
